import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["showOptionsFlag", "headerControls", "footerControls", "contentTabs", "paginationControls", "optionalContentControls", "optionalContent"];

    initialize() {
    }

    resetForm(e) {
        if (!e.target.form || !e.target.form.id) return;
        const key = e.target.form.id;
        // Reset all input fields
        document.querySelectorAll(`.${key}`).forEach(node => {
            if (node.getAttribute('defaultvalue') && node.children.length) {
                node.value = node.getAttribute('defaultvalue')
            } else {
                node.setAttribute('value', '');
            }
        });
        e.target.form.submit();
    }

    disconnect() {
    }
}
